<template>
  <a-dialog ref="dialog" name="create_api_token" :loading="loading" @close="$reset">
    <span slot="title">{{ $t('title') }}</span>
    <div slot="content">
      <v-form ref="form" v-model="form.valid">
        <v-text-field
          autofocus
          @keydown.enter.prevent=""
          :label="$t('fields.label.label')"
          v-model="form.fields.label"
          :rules="form.rules.label"
          required>
        </v-text-field>

        <v-select
          :items="[{text:$t('fields.scope.values.*'), value:'*'}]"
          v-model="form.fields.scope"
          :label="$t('fields.scope.label')"
          required
        ></v-select>
      </v-form>
    </div>
    <span slot="actions">
      <v-btn color="blue darken-1" :disabled="!form.valid" text @click="submit">
        {{ $t('actions.create') }}
      </v-btn>
    </span>
  </a-dialog>
</template>

<script>
export default {
  name: 'CreateApiTokenDialog',
  data () {
    return {
      loading: '',
      form: {
        fields: {
          label: '',
          scope: '*'
        },
        rules: {
          label: [v => !!v || this.$t('fields.label.rules.required')],
        },
        valid: false,
      }
    }
  },
  methods: {
    async submit () {
      this.loading = this.$t('loading')
      try {
        const token = (await this.$api.post('account/tokens/api', this.form.fields)).data
        if (this.$refs.dialog) this.$refs.dialog.close()
        this.$ui.openDialog('api_token_created', { token })
        this.$bus.emit('refresh_api_token_table')
      } finally {
        this.loading = ''
      }
    },
  }
}
</script>

<i18n>
{
	"en": {
		"fields": {
			"label": {
				"hint": "A custom name for this token.",
				"label": "Name",
				"rules": {
					"required": "A custom name is required."
				}
			},
			"scope": {
				"hint": "The accessible services for this token.",
				"label": "Scope",
				"values": {
					"*": "All (*)"
				}
			}
		},
		"loading": "Creating token ...",
		"title": "Create Api Token"
	},
	"es": {
		"fields": {
			"label": {
				"hint": "Un nombre personalizado para este token.",
				"label": "Nombre",
				"rules": {
					"required": "Se requiere un nombre personalizado."
				}
			},
			"scope": {
				"hint": "Los servicios accesibles para este token.",
				"label": "Alcance",
				"values": {
					"*": "Todo (*)"
				}
			}
		},
		"loading": "Creando token ...",
		"title": "Crear token de API"
	},
	"fr": {
		"fields": {
			"label": {
				"hint": "Un nom personnalisé pour ce token.",
				"label": "Prénom",
				"rules": {
					"required": "Un nom personnalisé est requis."
				}
			},
			"scope": {
				"hint": "Les services accessibles pour ce token.",
				"label": "Accès",
				"values": {
					"*": "Tout (*)"
				}
			}
		},
		"loading": "Création du token ...",
		"title": "Créer un token API"
	},
	"it": {
		"fields": {
			"label": {
				"hint": "Un nome personalizzato per questo token.",
				"label": "Nome",
				"rules": {
					"required": "È richiesto un nome personalizzato."
				}
			},
			"scope": {
				"hint": "I servizi accessibili per questo token.",
				"label": "Ambito",
				"values": {
					"*": "Tutto (*)"
				}
			}
		},
		"loading": "Creazione del token ...",
		"title": "Crea Token Api"
	},
	"pt": {
		"fields": {
			"label": {
				"hint": "Um nome personalizado para este token.",
				"label": "Nome",
				"rules": {
					"required": "É necessário um nome personalizado."
				}
			},
			"scope": {
				"hint": "Os serviços acessíveis para este token.",
				"label": "Âmbito",
				"values": {
					"*": "Tudo (*)"
				}
			}
		},
		"loading": "A criar token ...",
		"title": "Criar Token Api"
	},
	"pl": {
		"fields": {
			"label": {
				"hint": "Niestandardowa nazwa dla tego tokenu.",
				"label": "Nazwa",
				"rules": {
					"required": "Wymagana jest niestandardowa nazwa."
				}
			},
			"scope": {
				"hint": "Usługi dostępne dla tego tokenu.",
				"label": "Zakres",
				"values": {
					"*": "Wszystko (*)"
				}
			}
		},
		"loading": "Tworzenie tokenu ...",
		"title": "Utwórz token API"
	}
}
</i18n>

